import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Navigate } from 'react-router-dom';
import { getEnvironment, storeEnvironment, type TesEnvironment } from '../../lib/oauth';

export default function Login() {
  const { isAuthenticated, isLoading, login, error } = useAuth();
  const [environment, setEnvironment] = useState<TesEnvironment>(getEnvironment);

  const handleEnvironmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newEnv = e.target.value as TesEnvironment;
    setEnvironment(newEnv);
    storeEnvironment(newEnv);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="loading-pulse">
          <span className="font-mono text-sm text-grey-medium">Loading</span>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="max-w-md w-full mx-4">
        <div className="card p-8 text-left">
          {/* Logo */}
          <div className="mb-8">
            <div className="w-16 h-16 bg-black flex items-center justify-center mb-6">
              <svg
                className="w-10 h-10 text-mint"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
            <h1 className="text-h3 text-black mb-2">
              LLM Dashboard_
            </h1>
            <p className="text-grey-medium font-light">
              AI-powered analytics for the Takeback Event System
            </p>
          </div>

          {/* Error message */}
          {error && (
            <div className="mb-6 p-4 bg-coral/10 border-l-2 border-coral">
              <p className="text-sm text-coral">{error}</p>
            </div>
          )}

          {/* Environment selector */}
          <div className="mb-6">
            <label htmlFor="environment" className="block font-mono text-xs text-grey-medium uppercase tracking-wide mb-2">
              Environment
            </label>
            <select
              id="environment"
              value={environment}
              onChange={handleEnvironmentChange}
              className="w-full px-4 py-3 bg-grey-light text-black border-0 font-light focus:outline-none focus:ring-2 focus:ring-mint"
            >
              <option value="lego-test">lego-test</option>
              <option value="lego-live">lego-live</option>
            </select>
          </div>

          {/* Login button */}
          <button
            onClick={login}
            className="btn-primary w-full py-3"
          >
            Sign in with TES
          </button>

          {/* Footer */}
          <p className="mt-8 font-mono text-xs text-grey-medium">
            Powered by Cloudflare Workers AI
          </p>
        </div>
      </div>
    </div>
  );
}
